<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Assignment Group</h4>
          </div>

          <div class="card-body">
            <form [formGroup]="AssigmentForm">


              <div class="row">

  <div class="col-md-3">
    <div class="row">
      <div class="col-md-12">
        <button type="submit" class="btn-primary1" (click)="toggle()" >Add Group Name</button>
    </div>
  </div>
</div>
<div class="col-md-9">
  <div class="row" *ngIf="show">
   
    <div class="col-md-3">
       <label>Group Name</label>
    </div>
    <div class="col-md-6">
        <input class="form-control" placeholder="Enter Group Name" maxlength="50" [ngClass]="{ 'is-invalid': submitted && f.AddGroupName.errors }" formControlName="AddGroupName">
        <mat-error
                              *ngIf="GetFormControls('AddGroupName').invalid && (GetFormControls('AddGroupName').dirty || GetFormControls('AddGroupName').touched)"
                              class="ValidationError">
                              <mat-error *ngIf="GetFormControls('AddGroupName').errors.required">
                              Group Name is required.
                              </mat-error>
                            </mat-error>
    </div>
    <div class="col-md-3">
      <button type="submit" class="btn-primary1" (click)="addgroup()" >Save</button>
    </div>
  </div>
</div>
              </div>
              <div class="clearfix"></div>
              <br>
              <div class="row">

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Group Name</label></div>
                    <div class="col-md-7">
                      <!-- <input class="form-control" maxlength="30" [ngClass]="{ 'is-invalid': submitted && f.GroupName.errors }" formControlName="GroupName"> -->
                      <p-dropdown [options]="groupList" optionLabel="GroupName" placeholder="--Select--" formControlName="Group"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('Group').invalid && (GetFormControls('Group').dirty || GetFormControls('Group').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('Group').errors.required">
                    Group Name is required.
                    </mat-error>
                  </mat-error>
                         </div>
                         <div class="col-md-1"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Group/Lead Moderator</label></div>
                    <div class="col-md-7">
                      <!-- <input class="form-control" maxlength="30" [ngClass]="{ 'is-invalid': submitted && f.GroupName.errors }" formControlName="GroupName"> -->
                      <p-dropdown [options]="moderatorList" optionLabel="KeywordName" placeholder="--Select--" (onChange)="DisableLocation()" formControlName="Moderator"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('Moderator').invalid && (GetFormControls('Moderator').dirty || GetFormControls('Moderator').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('Moderator').errors.required">
                      Group/Lead Moderator is required.
                    </mat-error>
                  </mat-error>
                         </div>
                         <div class="col-md-1"></div>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <br>
              <div class="row">

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Location</label></div>
                    <div class="col-md-7">
                      <!-- <input class="form-control" maxlength="30" [ngClass]="{ 'is-invalid': submitted && f.GroupName.errors }" formControlName="GroupName"> -->
                      <p-dropdown [options]="locationList" optionLabel="location" placeholder="--Select--" (onChange)="ChangeModerator()" formControlName="Location"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('Location').invalid && (GetFormControls('Location').dirty || GetFormControls('Location').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('Location').errors.required">
                      Location is required.
                    </mat-error>
                  </mat-error>
                         </div>
                         <div class="col-md-1"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Employee Name</label></div>
           
                      <div class="col-md-8"> 
                        <p-autoComplete formControlName="EmpName" [suggestions]="requesterList"
                        (completeMethod)="SearchActiveEmployee($event)" placeholder="search name"
                        field="EmployeeName" [forceSelection]="true" [minLength]="3" size="37"
                        (onSelect)="SetEmployeeDetails($event)"  (onClear)="clearAutoComplete('EmpName')"
                      >
                    </p-autoComplete>
                    <mat-error
                    *ngIf="GetFormControls('EmpName').invalid && (GetFormControls('EmpName').dirty || GetFormControls('EmpName').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('EmpName').errors.required">
                      Employee Name is required.
                    </mat-error>
                  </mat-error>
                   
                      <!-- <small *ngIf="AssigmentForm.get('EmpName').invalid && AssigmentForm.get('EmpName').touched" class="text-danger">Employee Name Required</small> -->
                      </div>

                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <br>
                  
                </div>
                <div class="row">
                  <div class="col-md-4">

                  </div>

                  <div class="col-md-4">
                    <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit" class="btn-primary1" (click)="Adddata()" >Submit</button>
                    <button class="btn-primary1" (click)="Export()">Export as Excel</button>

                  </div>
                  <div class="col-md-4">
                  </div>
                  
                </div>
                <div class="clearfix"></div>

<!-- Added by Anmol Kaur -->
<div class="cardSearch2">
  <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseSearch"
    (click)="showhide()" role="button" aria-expanded="false" aria-controls="collapseSearch">
    <header class="panel-heading">
      <h5 class="panel-title">Search(Tap to Expand)</h5>
    </header> 
  </div>
  <div *ngIf="Ispanelshow" id="collapseSearch">
    <div class="card-body2">
      <div class="row">
        <div class="form-group2 col-md-6">
          <label class="required">Employee Name</label>
          <p-autoComplete formControlName="Employee" [suggestions]="requesterList"
            (completeMethod)="SearchActiveEmployee($event)" placeholder="Employee Name" field="EmployeeName"
            [forceSelection]="true" [minLength]="3" size="57" (onSelect)="SetEmployeeDetails($event)"
            (onClear)="clearAutoCompleteSearch('Employee')">
          </p-autoComplete>
        </div>
        <div class="form-group2 col-md-6">
          <label class="required">Assignment Group Name</label>
          <p-dropdown [options]="groupList" optionLabel="GroupName" placeholder="--Select--"
            formControlName="GroupSearch" filter="true" [showClear]="true">
          </p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="form-group2 col-md-6">
          <label class="required">Location</label>
          <p-dropdown [options]="locationList" optionLabel="location" placeholder="--Select--"
            formControlName="LocationSearch" filter="true" [showClear]="true">
          </p-dropdown>
        </div>
        <div class="form-group2 col-md-6">

        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">

        <div class="col-md-12" style="text-align:center;">
          <button class="btn-primary1" (click)="Exit()">Exit</button>
          <button class="btn-primary1" (click)="ResetData()">Reset</button>
          <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit"
            class="btn-primary1" (click)="GetResult()">Get Result</button>


        </div>

      </div>
    </div>
  </div>
</div>               
<!-- Ended by Anmol Kaur -->

<div class="clearfix"></div>


                <div class="row">
                  
                <div class="col-md-12">
                 
                  <div class="mat-elevation-z8 top-margin-border" #TABLE>
                    <table mat-table [dataSource]="AssigmentDataSourceView" #table style="width:100% !important">
           
                      <ng-container matColumnDef="Id">
                        <th mat-header-cell *matHeaderCellDef> Id </th>
                        <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowclickdata(element.Id)"> {{element.Id}} </td>
                      </ng-container>
            
                      <ng-container matColumnDef="GroupName">
                        <th mat-header-cell *matHeaderCellDef> Group Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.GroupName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="Moderator">
                        <th mat-header-cell *matHeaderCellDef> Group/Lead Moderator </th>
                        <td mat-cell *matCellDef="let element"> {{element.Moderator}} </td>
                      </ng-container>

                      <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef> Location </th>
                        <td mat-cell *matCellDef="let element"> {{element.location}} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="EmployeeGPN" >
                        <th mat-header-cell *matHeaderCellDef> Employee GPN </th>
                        <td mat-cell *matCellDef="let element" > {{element.EmpGPN}} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="EmployeeName">
                        <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.EmpName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="EmployeeEmail">
                        <th mat-header-cell *matHeaderCellDef> Employee Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.EmpEmail}} </td>
                      </ng-container>
          
                      <ng-container matColumnDef="GroupId">
                        <th mat-header-cell *matHeaderCellDef> Group Id </th>
                        <td mat-cell *matCellDef="let element"> {{element.GroupId}} </td>
                      </ng-container>

                      <ng-container matColumnDef="IsActive">
                        <th mat-header-cell *matHeaderCellDef> IsActive </th>
                        <td mat-cell *matCellDef="let element"> {{element.IsActive}} </td>
                      </ng-container>
          
                      <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
                      </ng-container>
            
                      <ng-container matColumnDef="Update">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="statusupdatedata(element.Id)"> Update Status </td>
                    
                      </ng-container>
            
                        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                    </table>
          <!-- <table mat-table [dataSource]="AssigmentDataSource" style="width:100% !important">
  
            <ng-container matColumnDef="EmployeeGPN" >
              <th mat-header-cell *matHeaderCellDef> Employee GPN </th>
              <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowclickdata(element.EmployeeGPN)"> {{element.EmployeeGPN}} </td>
            </ng-container>
                        
            <ng-container matColumnDef="EmployeeName">
              <th mat-header-cell *matHeaderCellDef> Employee Name </th>
              <td mat-cell *matCellDef="let element"> {{element.EmployeeName}} </td>
            </ng-container>
  
            <ng-container matColumnDef="GroupName">
              <th mat-header-cell *matHeaderCellDef> Group Name </th>
              <td mat-cell *matCellDef="let element"> {{element.GroupName}} </td>
            </ng-container>

            <ng-container matColumnDef="GroupId">
              <th mat-header-cell *matHeaderCellDef> Group Id </th>
              <td mat-cell *matCellDef="let element"> {{element.GroupId}} </td>
            </ng-container>
  
            <ng-container matColumnDef="Delete">
              <th mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowdeletedata(j)"> Remove </td>
            </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table> -->
          <mat-paginator  #paginator
          [length]="_global.length"
          [pageIndex]="_global.pageIndex"
          [pageSize]="_global.RecordSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPaginateChange1($event)"></mat-paginator>
        </div>
              </div>
              
                    <!-- <input type="button" value="Submit" class="btn btn-success" (click)="submitdata()" > -->

              
                </div>
             
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
